export const SCHEDULED_ORDER_LOADING = 'SCHEDULED_ORDER_LOADING';
export const SCHEDULED_ORDER_ERROR = 'SCHEDULED_ORDER_ERROR';
export const SCHEDULED_ORDER_SUCCESS = 'SCHEDULED_ORDER_SUCCESS';
